import { useEffect } from 'react';
import { usePrivy } from '@privy-io/react-auth';
import { useNavigate } from 'react-router-dom';
import ROUTES from '@/routes/routes-enums';
import SplashScreen from '@/pages/auth/SplashScreen/SplashScreen';
import LoadingSpinner from '@/components/LoadingSpinner';

import { useQueryClient } from '@tanstack/react-query';

const Logout = () => {
  const { authenticated, ready, logout } = usePrivy();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      console.log('[Logout] Starting logout process');

      try {
        // Clear admin check cache before logout
        queryClient.removeQueries({ queryKey: ['admin-check'] });

        await logout();
        console.log('[Logout] Logout completed successfully');
        navigate(ROUTES.AUTHENTICATION);
      } catch (error) {
        console.error('[Logout] Logout error:', error);
      }
    };

    // Only logout if authenticated
    if (ready && authenticated) {
      performLogout();
    }
  }, [ready, authenticated, logout, queryClient]);

  return (
    <SplashScreen>
      <div className="text-center">
        <LoadingSpinner size="23" />
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </SplashScreen>
  );
};

export default Logout;
